import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { webServiceCall } from "../../services/pantherService";

export default function StripeCallbackPage() {
  const { guid, action, serviceGUId } = useParams();
  const [message, setMessage] = useState("Processing transaction...");
  const navigate = useNavigate();

  useEffect(() => {
    const handleStripeCallback = async () => {
      let finalMessage = "Processing transaction...";

      try {
        const method =
          action === "success" ? "RecordStripePayment" : "VoidStripePayment";

        const result = await webServiceCall(method, {
          GUId: guid,
          ServiceGUId: serviceGUId,
        });

        finalMessage =
          action === "success" ? "Payment Successful!" : "Payment Cancelled!";
      } catch (err) {
        console.error("Stripe callback failed", err);
        finalMessage = err.message || "Error processing payment";
      }

      setMessage(finalMessage);

      setTimeout(() => {
        navigate(`/${guid}/dashboard`, {
          replace: true,
          state: { stripeMessage: finalMessage },
        });
      }, 1200); // 1.2s delay
    };

    handleStripeCallback();
  }, [guid, action, serviceGUId, navigate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>{message}</h2>
    </div>
  );
}
